export const pricingPolls = 'https://disqus.com/pricing/?product=polls';
export const pollsBlogPost = 'https://blog.disqus.com/disqus-polls-are-here-and-available-to-all-publishers';
